<template>
  <div class="mp-data-container">
    <!-- 搜索栏 -->
    <el-card class="search-card" shadow="hover">
      <el-form :inline="true" :model="queryParams" class="search-form">
        <el-form-item label="游戏名称">
          <el-select
              v-model="queryParams.gameName"
              placeholder="请选择游戏（可多选）"
              filterable
              clearable
              multiple
              collapse-tags
              style="width: 300px"
          >
            <el-option
                v-for="item in optionsGame"
                :key="item"
                :label="item"
                :value="item"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="注册渠道">
          <el-select
              v-model="queryParams.out_id"
              placeholder="请选择"
              clearable
              style="width: 140px"
              @change="handleChannelChange"
          >
            <el-option label="全部" value="" />
            <el-option label="腾讯广告" value="33" />
          </el-select>
        </el-form-item>

        <el-form-item
            v-if="queryParams.out_id === '33'"
            label="广告版位"
        >
          <el-select
              v-model="queryParams.placement_group"
              placeholder="请选择"
              clearable
              style="width: 180px"
          >
            <el-option label="全部" value="" />
            <el-option label="微信朋友圈" value="MD_PLACEMENT_GROUP_WX_MOMENT" />
            <el-option label="微信公众号和小程序" value="MD_PLACEMENT_GROUP_WX_BIZ_WEAPP" />
            <el-option label="搜索" value="MD_PLACEMENT_GROUP_SEARCH" />
            <el-option label="其他" value="MD_PLACEMENT_GROUP_OTHER" />
            <el-option label="腾讯平台和内容媒体" value="MD_PLACEMENT_GROUP_PCAD" />
            <el-option label="微信视频号" value="MD_PLACEMENT_GROUP_WX_FINDER" />
            <el-option label="优量汇" value="MD_PLACEMENT_GROUP_YLH" />
          </el-select>
        </el-form-item>

        <el-form-item
            v-if="queryParams.out_id === '33'"
            label="广告创意"
        >
          <el-select
              v-model="queryParams.creative_type"
              placeholder="请选择"
              clearable
              style="width: 140px"
              @change="handleCreativeTypeChange"
          >
            <el-option label="全部" value="" />
            <el-option label="激励试玩" value="MD_CREATIVE_TYPE_REWARDED_CANVAS" />
            <el-option label="图片" value="MD_CREATIVE_TYPE_IMG" />
            <el-option label="搜索" value="MD_CREATIVE_TYPE_SEARCH" />
            <el-option label="视频" value="MD_CREATIVE_TYPE_VIDEO" />
            <el-option label="格子" value="MD_CREATIVE_TYPE_BOX" />
            <el-option label="其他" value="MD_CREATIVE_TYPE_OTHER" />
          </el-select>
        </el-form-item>

        <el-form-item
            v-if="queryParams.out_id === '33' && queryParams.creative_type === 'MD_CREATIVE_TYPE_REWARDED_CANVAS'"
            label="创意尺寸"
        >
          <el-select
              v-model="queryParams.creative_size"
              placeholder="请选择"
              clearable
              style="width: 140px"
          >
            <el-option label="全部" value="" />
            <el-option label="试玩" value="2264" />
            <el-option label="直玩" value="2610" />
          </el-select>
        </el-form-item>

        <el-form-item label="日期范围">
          <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyyMMdd"
              style="width: 260px"
              @change="handleDateChange"
              :picker-options="pickerOptions"
          />
        </el-form-item>

        <el-form-item label="数据展示">
          <el-checkbox v-model="showAdRevenue">含广告金</el-checkbox>
        </el-form-item>

        <el-form-item>
          <el-button
              type="primary"
              @click="handleSearch"
              :loading="loading"
              icon="el-icon-search"
          >
            查询
          </el-button>
          <el-button
              @click="resetSearch"
              icon="el-icon-refresh-right"
              v-if="hasSearchParams"
          >
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 数据表格区域 -->
    <el-card class="table-card" shadow="hover">
      <div slot="header" class="card-header">
<!--        <div class="header-left">-->
<!--          <i class="el-icon-data-line"></i>-->
<!--          <span>变现数据详情 (0-90日 ROI)</span>-->
<!--        </div>-->
<!--        <div class="header-right">-->
<!--          <el-tag size="mini" type="info">实际数据</el-tag>-->
<!--          <el-tag size="mini" type="warning" style="margin-left: 8px">预估数据</el-tag>-->
<!--        </div>-->
      </div>

      <div class="table-wrapper">
        <el-table
            :data="displayTableData"
            highlight-current-row
            size="small"
            stripe
            row-key="reg_ds"
            v-loading="loading"
            height="calc(100vh - 240px)"
            :default-sort="{prop: 'reg_ds', order: 'descending'}"
        >
          <!-- 固定左侧列组 -->
          <el-table-column
              prop="reg_ds"
              label="注册日期"
              width="100"
              fixed
              sortable
          >
            <template slot-scope="scope">
              <span v-if="scope.row._isSummary" class="summary-text">汇总</span>
              <span v-else class="date-text">{{ formatDate(scope.row.reg_ds) }}</span>
            </template>
          </el-table-column>

          <el-table-column
              prop="gameName"
              label="游戏名称"
              width="150"
              fixed
          >
            <template slot-scope="scope">
              <span v-if="scope.row._isSummary" class="summary-text">-</span>
              <span v-else class="game-name-text">{{ scope.row.gameName }}</span>
            </template>
          </el-table-column>

<!--          <el-table-column-->
<!--              prop="reg_uv"-->
<!--              label="注册人数"-->
<!--              width="100"-->
<!--              align="right"-->
<!--              fixed-->
<!--          >-->
<!--            <template slot-scope="scope">-->
<!--              <span v-if="scope.row._isSummary" class="summary-number">{{ formatNumber(scope.row.reg_uv, 0) }}</span>-->
<!--              <span v-else class="number-value">{{ formatNumber(scope.row.reg_uv, 0) }}</span>-->
<!--            </template>-->
<!--          </el-table-column>-->

          <el-table-column
              prop="ad_cost"
              label="消耗"
              width="110"
              fixed
          >
            <template slot-scope="scope">
              <span v-if="scope.row._isSummary" class="summary-number">{{ formatNumber(scope.row.ad_cost) }}</span>
              <span v-else class="number-value">{{ formatNumber(scope.row.ad_cost) }}</span>
            </template>
          </el-table-column>

<!--          <el-table-column-->
<!--              prop="cpa"-->
<!--              label="CPA"-->
<!--              width="80"-->
<!--              align="right"-->
<!--              fixed-->
<!--          >-->
<!--            <template slot-scope="scope">-->
<!--              <span v-if="scope.row._isSummary" class="summary-number">¥{{ formatNumber(scope.row.cpa) }}</span>-->
<!--              <span v-else class="number-value">¥{{ formatNumber(scope.row.cpa) }}</span>-->
<!--            </template>-->
<!--          </el-table-column>-->

          <el-table-column
              prop="estimated_profit"
              label="预估利润"
              width="110"
              fixed
          >
            <template slot-scope="scope">
              <span v-if="scope.row._isSummary" class="summary-number">{{ formatNumber(scope.row.estimated_profit) }}</span>
              <span v-else :class="getEstimatedProfit(scope.row) > 0 ? 'profit-positive' : (getEstimatedProfit(scope.row) < 0 ? 'profit-negative' : 'profit-zero')">
                {{ formatNumber(getEstimatedProfit(scope.row)) }}
              </span>
            </template>
          </el-table-column>

          <el-table-column
              prop="estimated_roi_60"
              label="预估ROI|倍率"
              width="140"
              align="center"
              fixed
          >
            <template slot-scope="scope">
              <!-- 汇总行显示 -->
              <div v-if="scope.row._isSummary">
                <span :class="scope.row['roi_day_60_is_fit'] ? 'yugu' : 'yugu2'">
                  {{ (scope.row['roi_day_60'] * 100).toFixed(2) }}%
                </span>
                <span class="roi-ratio-fit">| {{ getFitRatioForSummary(scope.row, 90) }}</span>
              </div>
              <!-- 普通数据行显示 -->
              <div v-else class="roi-cell">
                <!-- 实际数据优先 -->
                <div v-if="hasRealData(scope.row, 89)" class="roi-real">
                  <div v-if="showAdRevenue" class="roi-item all">
                    <span class="roi-value yugu2">{{ getRealRoiAll(scope.row, 89) }}%</span>
                    <span class="roi-ratio">| {{ getRealRoiRatioAll(scope.row, 89) }}</span>
                  </div>
                  <div v-else class="roi-item monetize">
                    <span class="roi-value yugu2">{{ getRealRoiMonetize(scope.row, 89) }}%</span>
                    <span class="roi-ratio">| {{ getRealRoiRatioMonetize(scope.row, 89) }}</span>
                  </div>
                </div>
                <!-- 预估数据：直接有60天预估数据时显示星标 -->
                <div v-else-if="hasAnyFitData(scope.row, 90)" class="roi-fit">
                  <div v-if="showAdRevenue" class="roi-item all fit">
                    <i class="el-icon-star-on updated-marker-icon"></i>
                    <span class="roi-value yugu">{{ getFitRoiAll(scope.row, 90) }}%</span>
                    <span class="roi-ratio-fit">| {{ getFitRatioAll(scope.row, 90) }}</span>
                  </div>
                  <div v-else class="roi-item monetize fit">
                    <i class="el-icon-star-on updated-marker-icon"></i>
                    <span class="roi-value yugu">{{ getFitRoiMonetize(scope.row, 90) }}%</span>
                    <span class="roi-ratio-fit">| {{ getFitRatioMonetize(scope.row, 90) }}</span>
                  </div>
                </div>
                <!-- 其他情况：通过拟合/插值计算的数据，不显示星标 -->
                <div v-else class="roi-fit">
                  <div v-if="showAdRevenue" class="roi-item all fit">
                    <span class="yugu">{{ getFitRoiAll(scope.row, 90) }}%</span>
                    <span class="roi-ratio-fit">| {{ getFitRatioAll(scope.row, 90) }}</span>
                  </div>
                  <div v-else class="roi-item monetize fit">
                    <span class="yugu">{{ getFitRoiMonetize(scope.row, 90) }}%</span>
                    <span class="roi-ratio-fit">| {{ getFitRatioMonetize(scope.row, 90) }}</span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>


          <el-table-column
              prop="roi_period"
              label="预估周期"
              width="90"
              align="center"
              fixed
          >
            <template slot-scope="scope">
              <span v-if="scope.row._isSummary">-</span>
              <span v-else >90</span>
            </template>
          </el-table-column>

          <!-- 动态生成 ROI 列 -->
          <el-table-column
              v-for="day in roiDisplayDays"
              :key="'col-' + day"
              :label="`${day}日ROI`"
              width="140"
              align="center"
              class-name="roi-column"
          >
            <template slot-scope="scope">
              <!-- 汇总行显示 -->
              <div v-if="scope.row._isSummary" >
                <span :class="scope.row[`roi_day_${day}_is_fit`] ? 'yugu' : 'yugu2'">
                  {{ (scope.row[`roi_day_${day}`] * 100).toFixed(2) }}%
                </span><span class="roi-ratio-fit">| {{ getFitRatioForSummary(scope.row, day) }}</span>
              </div>
              <!-- 普通数据行显示 -->
              <div v-else class="roi-cell">
                <!-- 实际数据 -->
                <div v-if="hasRealData(scope.row, day - 1)" class="roi-real">
                  <div v-if="showAdRevenue" class="roi-item all">
                    <span class="roi-value yugu2">{{ getRealRoiAll(scope.row, day - 1) }}%</span>
                    <span class="roi-ratio">| {{ getRealRoiRatioAll(scope.row, day - 1) }}</span>
                  </div>
                  <div v-else class="roi-item monetize">
                    <span class="roi-value yugu2">{{ getRealRoiMonetize(scope.row, day - 1) }}%</span>
                    <span class="roi-ratio">| {{ getRealRoiRatioMonetize(scope.row, day - 1) }}</span>
                  </div>
                </div>

                <!-- 1-13 天：有第 14 天预估数据时，拟合缺失的 -->
                <div v-else-if="day <= 13 && shouldFitMissingDays(scope.row)" class="roi-fit">
                  <div v-if="showAdRevenue" class="roi-item all fit">
                    <span class="yugu">{{ getFitRoiAll(scope.row, day) }}%</span>
                    <span class="roi-ratio-fit">| {{ getFitRatioAll(scope.row, day) }}</span>
                  </div>
                  <div v-else class="roi-item monetize fit">
                    <span class="yugu">{{ getFitRoiMonetize(scope.row, day) }}%</span>
                    <span class="roi-ratio-fit">| {{ getFitRatioMonetize(scope.row, day) }}</span>
                  </div>
                </div>

                <!-- 预估数据：14、60、90 天本身 -->
                <div v-else-if="isFitDay(day) && hasAnyFitData(scope.row, day)" class="roi-fit">
                  <div v-if="showAdRevenue" class="roi-item all fit">
                    <i class="el-icon-star-on updated-marker-icon"></i>
                    <span class="roi-value yugu">{{ getFitRoiAll(scope.row, day) }}%</span>
                    <span class="roi-ratio-fit">| {{ getFitRatioAll(scope.row, day) }}</span>
                  </div>
                  <div v-else class="roi-item monetize fit">
                    <i class="el-icon-star-on updated-marker-icon"></i>
                    <span class="roi-value yugu">{{ getFitRoiMonetize(scope.row, day) }}%</span>
                    <span class="roi-ratio-fit">| {{ getFitRatioMonetize(scope.row, day) }}</span>
                  </div>
                </div>

                <!-- 14-59 天：有 14 和 60 预估数据时，拟合中间缺失的 -->
                <div v-else-if="day > 14 && day < 60 && scope.row._fitData && scope.row._fitData['predicted_all_income_roi_14'] !== null && scope.row._fitData['predicted_all_income_roi_60'] !== null" class="roi-fit">
                  <div v-if="showAdRevenue" class="roi-item all fit">
                    <span class="yugu">{{ getFitRoiAll(scope.row, day) }}%</span>
                    <span class="roi-ratio-fit">| {{ getFitRatioAll(scope.row, day) }}</span>
                  </div>
                  <div v-else class="roi-item monetize fit">
                    <span class="yugu">{{ getFitRoiMonetize(scope.row, day) }}%</span>
                    <span class="roi-ratio-fit">| {{ getFitRatioMonetize(scope.row, day) }}</span>
                  </div>
                </div>

                <!-- 60-89 天：有 60 和 90 预估数据时，拟合中间缺失的 -->
                <div v-else-if="day > 60 && day < 90 && scope.row._fitData && scope.row._fitData['predicted_all_income_roi_60'] !== null && scope.row._fitData['predicted_all_income_roi_90'] !== null" class="roi-fit">
                  <div v-if="showAdRevenue" class="roi-item all fit">
                    <span class="yugu">{{ getFitRoiAll(scope.row, day) }}%</span>
                    <span class="roi-ratio-fit">| {{ getFitRatioAll(scope.row, day) }}</span>
                  </div>
                  <div v-else class="roi-item monetize fit">
                    <span class="yugu">{{ getFitRoiMonetize(scope.row, day) }}%</span>
                    <span class="roi-ratio-fit">| {{ getFitRatioMonetize(scope.row, day) }}</span>
                  </div>
                </div>
                <!-- ROI90 本身 -->
                <div v-else-if="day === 90 && hasAnyFitData(scope.row, 90)" class="roi-fit">
                  <div v-if="showAdRevenue" class="roi-item all fit">
                    <i class="el-icon-star-on updated-marker-icon"></i>
                    <span class="roi-value yugu">{{ getFitRoiAll(scope.row, 90) }}%</span>
                    <span class="roi-ratio-fit">| {{ getFitRatioAll(scope.row, 90) }}</span>
                  </div>
                  <div v-else class="roi-item monetize fit">
                    <i class="el-icon-star-on updated-marker-icon"></i>
                    <span class="roi-value yugu">{{ getFitRoiMonetize(scope.row, 90) }}%</span>
                    <span class="roi-ratio-fit">| {{ getFitRatioMonetize(scope.row, 90) }}</span>
                  </div>
                </div>
                <!-- 没有第 14 天预估数据时，用对数拟合所有缺失的（1-60 天） -->
                <div v-else class="roi-fit">
                  <div v-if="showAdRevenue" class="roi-item all fit">
                    <span class="yugu">{{ getFitRoiAll(scope.row, day) }}%</span>
                    <span class="roi-ratio-fit">| {{ getFitRatioAll(scope.row, day) }}</span>
                  </div>
                  <div v-else class="roi-item monetize fit">
                    <span class="yugu">{{ getFitRoiMonetize(scope.row, day) }}%</span>
                    <span class="roi-ratio-fit">| {{  getFitRatioMonetize(scope.row, day) }}</span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'MpDataDub',
  data() {
    const daysContinuous = Array.from({ length: 31 }, (_, i) => i + 1);
    const daysExtra = [60, 90,91];
    return {
      loading: false,
      tableData: [],
      queryParams: {
        gameName: [], // 改为数组支持多选
        action: 'get_md_roi_trace',
        begin_ds: '',
        end_ds: '',
        out_id: '',
        placement_group: '',
        creative_type: '',
        creative_size: ''
      },
      optionsGame: [],
      roiDisplayDays: [ ...daysContinuous, ...daysExtra],
      dateRange: [],
      showAdRevenue: true,
      profitCache: {}, // 预估利润缓存
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      }
    };
  },
  computed: {
    hasSearchParams() {
      return (this.queryParams.gameName && this.queryParams.gameName.length > 0) ||
          this.queryParams.out_id ||
          this.queryParams.placement_group ||
          this.queryParams.creative_type ||
          (this.queryParams.begin_ds && this.queryParams.end_ds);
    },

    // 计算显示的数据（包含汇总行）
    displayTableData() {
      if (!this.tableData || this.tableData.length === 0) {
        return [];
      }

      // 生成汇总行数据
      const summaryRow = this.generateSummaryRow();

      // 将汇总行放在第一行
      return [summaryRow, ...this.tableData];
    },

  },
  mounted() {
    this.findGame();
  },
  methods: {

    shouldFitMissingDays(row) {
      const hasDay14Fit = row._fitData &&
          (row._fitData['predicted_all_income_roi_14'] !== null ||
              row._fitData['predicted_monetize_income_roi_14'] !== null);

      if (!hasDay14Fit) return false;

      for (let day = 0; day < 13; day++) {
        if (!this.hasRealData(row, day)) {
          return true;
        }
      }
      return false;
    },

    fitLogarithmicCurve(points, targetX) {
      if (points.length < 2) return null;

      const n = points.length;
      let sumlnX = 0, sumY = 0, sumlnXsq = 0, sumXlnX = 0;

      points.forEach(p => {
        const lnX = Math.log(p.x);
        sumlnX += lnX;
        sumY += p.y;
        sumlnXsq += lnX * lnX;
        sumXlnX += p.y * lnX;
      });

      const denom = n * sumlnXsq - sumlnX * sumlnX;
      if (Math.abs(denom) < 1e-10) return null;

      const b = (n * sumXlnX - sumlnX * sumY) / denom;
      const a = (sumY - b * sumlnX) / n;

      return a + b * Math.log(targetX);
    },

    collectRealDataPoints(row, type, maxDay) {
      const points = [];
      const limit = maxDay || 13;

      for (let d = 0; d < limit; d++) {
        if (this.hasRealData(row, d)) {
          const roiKey = type === 'all' ? 'roi_all' : 'roi_monetize';
          const val = row._roiMap[d][roiKey];
          if (val !== undefined && val !== null) {
            points.push({ x: d + 1, y: val });
          }
        }
      }
      return points;
    },

    linearInterpolate(sortedPoints, targetX) {
      if (sortedPoints.length === 0) return null;

      if (targetX <= sortedPoints[0].x) {
        return sortedPoints[0].y;
      }

      for (let i = 0; i < sortedPoints.length - 1; i++) {
        if (targetX >= sortedPoints[i].x && targetX <= sortedPoints[i + 1].x) {
          const x1 = sortedPoints[i].x;
          const y1 = sortedPoints[i].y;
          const x2 = sortedPoints[i + 1].x;
          const y2 = sortedPoints[i + 1].y;

          if (x2 === x1) {
            return y1;
          }

          const ratio = (targetX - x1) / (x2 - x1);
          return y1 + (y2 - y1) * ratio;
        }
      }

      return sortedPoints[sortedPoints.length - 1].y;
    },

    calculateFitValue(row, day, type) {
      const fitData = row._fitData;

      const directKey = type === 'all' ? 'predicted_all_income_roi_' + day : 'predicted_monetize_income_roi_' + day;
      const directVal = fitData ? fitData[directKey] : null;

      if (directVal !== undefined && directVal !== null) {
        return directVal;
      }

      const realPoints = this.collectRealDataPoints(row, type, 13);

      const fit14Key = type === 'all' ? 'predicted_all_income_roi_14' : 'predicted_monetize_income_roi_14';
      const fit14Val = fitData ? fitData[fit14Key] : null;

      const fit60Key = type === 'all' ? 'predicted_all_income_roi_60' : 'predicted_monetize_income_roi_60';
      const fit60Val = fitData ? fitData[fit60Key] : null;

      const fit90Key = type === 'all' ? 'predicted_all_income_roi_90' : 'predicted_monetize_income_roi_90';
      const fit90Val = fitData ? fitData[fit90Key] : null;

      // 情况 1：有第 14 天预估数据
      if (fit14Val !== null && fit14Val !== undefined) {
        const allPoints = [...realPoints];

        if (day < 14) {
          allPoints.push({ x: 14, y: fit14Val });
          const sorted = allPoints.sort((a, b) => a.x - b.x);
          return this.linearInterpolate(sorted, day);
        }

        if (day === 60 && fit60Val !== null && fit60Val !== undefined) {
          allPoints.push({ x: 14, y: fit14Val });
          allPoints.push({ x: 60, y: fit60Val });
          const sorted = allPoints.sort((a, b) => a.x - b.x);
          return this.linearInterpolate(sorted, day);
        }

        if (day === 90 && fit60Val !== null && fit60Val !== undefined && fit90Val !== null && fit90Val !== undefined) {
          allPoints.push({ x: 14, y: fit14Val });
          allPoints.push({ x: 60, y: fit60Val });
          allPoints.push({ x: 90, y: fit90Val });
          const sorted = allPoints.sort((a, b) => a.x - b.x);
          return this.linearInterpolate(sorted, day);
        }

        // 14-59 天之间有 14 和 60 的数据
        if (day > 14 && day < 60 && fit60Val !== null && fit60Val !== undefined) {
          allPoints.push({ x: 14, y: fit14Val });
          allPoints.push({ x: 60, y: fit60Val });
          const sorted = allPoints.sort((a, b) => a.x - b.x);
          return this.linearInterpolate(sorted, day);
        }

        // 60-89 天之间有 60 和 90 的数据
        if (day > 60 && day < 90 && fit60Val !== null && fit60Val !== undefined && fit90Val !== null && fit90Val !== undefined) {
          allPoints.push({ x: 14, y: fit14Val });
          allPoints.push({ x: 60, y: fit60Val });
          allPoints.push({ x: 90, y: fit90Val });
          const sorted = allPoints.sort((a, b) => a.x - b.x);
          return this.linearInterpolate(sorted, day);
        }
      }

      // 情况 2：没有第 14 天预估数据，使用对数拟合所有天数
      if (realPoints.length >= 2) {
        const fittedValue = this.fitLogarithmicCurve(realPoints, day);
        console.log(`对数拟合 day=${day}, result=`, fittedValue, 'points=', realPoints);
        if (fittedValue !== null && fittedValue > 0) {
          return fittedValue;
        }
      }

      return null;
    },

    getFitRoiAll(row, day) {
      const directKey = 'predicted_all_income_roi_' + day;

      if (row._fitData) {
        const directVal = row._fitData[directKey];
        if (directVal !== undefined && directVal !== null) {
          return (directVal * 100).toFixed(2);
        }
      }

      const fittedVal = this.calculateFitValue(row, day, 'all');
      console.log(`getFitRoiAll day=${day}, fittedVal=`, fittedVal);
      if (fittedVal !== null && fittedVal > 0) {
        return (fittedVal * 100).toFixed(2);
      }

      return '0.00';
    },

    getFitRoiMonetize(row, day) {
      const directKey = 'predicted_monetize_income_roi_' + day;

      if (row._fitData) {
        const directVal = row._fitData[directKey];
        if (directVal !== undefined && directVal !== null) {
          return (directVal * 100).toFixed(2);
        }
      }

      const fittedVal = this.calculateFitValue(row, day, 'monetize');
      if (fittedVal !== null && fittedVal > 0) {
        return (fittedVal * 100).toFixed(2);
      }

      return '0.00';
    },

    hasAnyFitData(row, day) {
      if (!row._fitData) return false;
      const keyAll = 'predicted_all_income_roi_' + day;
      return row._fitData[keyAll] !== undefined && row._fitData[keyAll] !== null;
    },

    canFitWithLog(row) {
      if (!row._fitData) return false;
      const fit14 = row._fitData['predicted_all_income_roi_14'];
      const hasFit14 = fit14 !== null && fit14 !== undefined;
      const hasRealData = Object.keys(row._roiMap || {}).length > 0;
      if (!hasFit14 && hasRealData) {
        console.log('可以对数拟合，实际数据点:', row._roiMap);
        return true;
      }
      return false;
    },

    shouldShowLogFit(row, day) {
      if (![14, 30, 60, 90].includes(day)) return false;

      const fitData = row._fitData;
      const fit14 = fitData ? fitData['predicted_all_income_roi_14'] : null;
      const hasFit14 = fit14 !== null && fit14 !== undefined;

      if (hasFit14) return false;

      const realPoints = this.collectRealDataPoints(row, 'all', 13);
      return realPoints.length >= 2;
    },

    getRealRoiRatioAll(row, day) {
      if (!this.hasRealData(row, day)) return '0.00';
      const val = row._roiMap[day].roi_ratio_all;
      return (val !== undefined && val !== null) ? Number(val).toFixed(2) : '0.00';
    },

    getRealRoiRatioMonetize(row, day) {
      if (!this.hasRealData(row, day)) return '0.00';
      const val = row._roiMap[day].roi_ratio_monetize;
      return (val !== undefined && val !== null) ? Number(val).toFixed(2) : '0.00';
    },

    handleChannelChange(val) {
      if (val !== '33') {
        this.queryParams.placement_group = '';
        this.queryParams.creative_type = '';
        this.queryParams.creative_size = '';
      }
    },

    handleCreativeTypeChange(val) {
      // 如果不是激励广告,清空创意尺寸
      if (val !== 'MD_CREATIVE_TYPE_REWARDED_CANVAS') {
        this.queryParams.creative_size = '';
      }
    },

    isFitDay(day) {
      return [14, 30, 60, 90].includes(day);
    },

    hasRealData(row, day) {
      return row._roiMap && row._roiMap[day];
    },

    getRealRoiAll(row, day) {
      if (!this.hasRealData(row, day)) return '0.00';
      const val = row._roiMap[day].roi_all;
      return (val * 100).toFixed(2);
    },

    getRealRoiMonetize(row, day) {
      if (!this.hasRealData(row, day)) return '0.00';
      const val = row._roiMap[day].roi_monetize;
      return (val * 100).toFixed(2);
    },

    getEstimatedProfit(row) {
      // 修复：缓存 key 需要包含 gameName，避免不同游戏的相同日期数据混淆
      const rowKey = row.gameName + '_' + row.reg_ds + '_' + (this.showAdRevenue ? 'all' : 'monetize');

      // 检查缓存中是否有计算结果
      if (this.profitCache[rowKey] !== undefined) {
        return this.profitCache[rowKey];
      }

      // 获取 ROI90 的值（索引为 89）
      let roi90 = 0;

      // 优先从实际数据中获取
      if (this.hasRealData(row, 89)) {
        const roiKey = this.showAdRevenue ? 'roi_all' : 'roi_monetize';
        roi90 = row._roiMap[89][roiKey] || 0;
      } else if (row._fitData) {
        // 如果没有实际数据，使用拟合数据
        const fitKey = this.showAdRevenue ? 'predicted_all_income_roi_90' : 'predicted_monetize_income_roi_90';
        roi90 = row._fitData[fitKey];
      }

      // 如果还是没有 90 天的数据，尝试使用 calculateFitValue 计算（包括对数拟合）
      if (!roi90 || roi90 <= 0) {
        const fittedRoi90 = this.calculateFitValue(row, 90, this.showAdRevenue ? 'all' : 'monetize');
        if (fittedRoi90 !== null && fittedRoi90 > 0) {
          roi90 = fittedRoi90;
        }
      }

      // 如果还是获取不到 ROI90，返回 0
      if (!roi90 || roi90 <= 0) {
        // 缓存结果
        this.profitCache[rowKey] = 0;
        return 0;
      }

      // 预估利润 = 广告消耗 * (ROI90 - 1)
      const adCost = row.ad_cost || 0;
      const profit = adCost * (roi90 - 1);

      // 缓存结果
      this.profitCache[rowKey] = profit;
      return profit;
    },

    getFitRatioAll(row, day) {
      // 计算倍率：当前天数ROI / 首日ROI
      const currentRoi = this.calculateFitValue(row, day, 'all');
      if (!currentRoi || currentRoi <= 0) return '0.00';

      // 获取首日ROI
      let day0Roi = 0;
      if (this.hasRealData(row, 0)) {
        day0Roi = row._roiMap[0].roi_all || 0;
      } else if (row._fitData) {
        day0Roi = row._fitData['predicted_all_income_roi_1'] || 0;
      }

      if (!day0Roi || day0Roi <= 0) return '0.00';

      const ratio = currentRoi / day0Roi;
      return ratio.toFixed(2);
    },

    getFitRatioMonetize(row, day) {
      // 计算倍率：当前天数ROI / 首日ROI
      const currentRoi = this.calculateFitValue(row, day, 'monetize');
      if (!currentRoi || currentRoi <= 0) return '0.00';

      // 获取首日ROI
      let day0Roi = 0;
      if (this.hasRealData(row, 0)) {
        day0Roi = row._roiMap[0].roi_monetize || 0;
      } else if (row._fitData) {
        day0Roi = row._fitData['predicted_monetize_income_roi_1'] || 0;
      }

      if (!day0Roi || day0Roi <= 0) return '0.00';

      const ratio = currentRoi / day0Roi;
      return ratio.toFixed(2);
    },

    // 获取汇总行的倍率（用于预估ROI列）
    getFitRatioForSummary(row, day) {
      // 汇总行直接使用 roi_day_${day} 的值计算倍率
      const roiDay = row[`roi_day_${day}`];
      if (!roiDay || roiDay <= 0) return '0.00';

      // 获取汇总行的首日ROI
      const roiDay1 = row['roi_day_1'];
      if (!roiDay1 || roiDay1 <= 0) return '0.00';

      const ratio = roiDay / roiDay1;
      return ratio.toFixed(2);
    },

    handleDateChange(val) {
      if (val && val.length === 2) {
        this.queryParams.begin_ds = val[0];
        this.queryParams.end_ds = val[1];
      } else {
        this.queryParams.begin_ds = '';
        this.queryParams.end_ds = '';
      }
    },

    resetSearch() {
      this.queryParams = {
        gameName: [], // 改为数组
        action: 'get_md_roi_trace',
        begin_ds: '',
        end_ds: '',
        out_id: '',
        placement_group: '',
        creative_type: '',
        creative_size: ''
      };
      this.dateRange = [];
      // 清除缓存
      this.profitCache = {};
      this.handleSearch();
    },

    formatDate(dateStr) {
      if (!dateStr) return '';
      return `${dateStr.slice(0, 4)}-${dateStr.slice(4, 6)}-${dateStr.slice(6, 8)}`;
    },

    findGame() {
      this.$axios.get('/toufangWx/data/findName', {})
          .then(successResponse => {
            this.optionsGame = successResponse.data.data || [];
          })
          .catch(error => {
            console.error('获取游戏列表失败:', error);
          });
    },

    formatNumber(val, decimals = 2) {
      if (val === null || val === undefined) return '0.00';
      return Number(val).toLocaleString('zh-CN', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      });
    },

    // 生成汇总行数据
    generateSummaryRow() {
      const data = this.tableData;
      if (!data || data.length === 0) {
        return {};
      }

      // 计算总消耗（所有行都参与）
      const totalAdCost = data.reduce((sum, item) => sum + (item.ad_cost || 0), 0);
      const totalRegUv = data.reduce((sum, item) => sum + (item.reg_uv || 0), 0);

      // 创建汇总行对象
      const summaryRow = {
        reg_ds: '合计', // 特殊标识
        _isSummary: true,
        reg_uv: totalRegUv,
        ad_cost: totalAdCost,
        cpa: totalRegUv > 0 ? totalAdCost / totalRegUv : 0,
        estimated_profit: data.reduce((sum, item) => sum + this.getEstimatedProfit(item), 0)
      };

      // 计算每一天的 ROI（只有有 60 日数据的行才参与）
      this.roiDisplayDays.forEach(day => {
        const dayIndex = day - 1;
        let totalIncome = 0;
        let validCost = 0;
        let hasFitData = false; // 标记是否有预估数据参与
      
        data.forEach(item => {
          // 检查该行是否有 60 日 ROI 数据
          const hasDay60Data = this.checkHasDay60Data(item);
      
          // 如果没有 60 日数据，跳过该行
          if (!hasDay60Data) {
            return;
          }
      
          let roiValue = 0;
          const adCost = item.ad_cost || 0;
      
          // 尝试获取该天的 ROI
          if (this.hasRealData(item, dayIndex)) {
            // 有实际数据
            const roiKey = this.showAdRevenue ? 'roi_all' : 'roi_monetize';
            roiValue = item._roiMap[dayIndex][roiKey] || 0;
          } else if (item._fitData) {
            // 尝试从拟合数据获取
            const fitKey = this.showAdRevenue 
              ? 'predicted_all_income_roi_' + day 
              : 'predicted_monetize_income_roi_' + day;
            roiValue = item._fitData[fitKey];
                  
            if (roiValue === null || roiValue === undefined) {
              roiValue = this.calculateFitValue(item, day, this.showAdRevenue ? 'all' : 'monetize') || 0;
            }
            hasFitData = true; // 标记有预估数据
          } else {
            // 使用 calculateFitValue
            roiValue = this.calculateFitValue(item, day, this.showAdRevenue ? 'all' : 'monetize') || 0;
            hasFitData = true; // 标记有预估数据
          }
      
          totalIncome += adCost * roiValue;
          validCost += adCost;
        });
      
        // 存储加权平均 ROI（小数形式）
        const avgRoi = validCost > 0 ? totalIncome / validCost : 0;
        summaryRow[`roi_day_${day}`] = avgRoi;
        summaryRow[`roi_day_${day}_is_fit`] = hasFitData; // 标记是否有预估数据
      });

      return summaryRow;
    },

    // 检查某行是否有 60 日 ROI 数据
    checkHasDay60Data(row) {
      // 检查是否有实际 60 日数据（索引 59）
      if (this.hasRealData(row, 59)) {
        const roiKey = this.showAdRevenue ? 'roi_all' : 'roi_monetize';
        const roiValue = row._roiMap[59][roiKey];
        if (roiValue !== undefined && roiValue !== null && roiValue > 0) {
          return true;
        }
      }

      // 检查是否有预估 60 日数据
      if (row._fitData) {
        const fitKey = this.showAdRevenue
          ? 'predicted_all_income_roi_60'
          : 'predicted_monetize_income_roi_60';
        const fitValue = row._fitData[fitKey];
        if (fitValue !== undefined && fitValue !== null && fitValue > 0) {
          return true;
        }
      }

      // 检查是否可以通过 calculateFitValue 计算出 60 日数据
      const fittedValue = this.calculateFitValue(row, 60, this.showAdRevenue ? 'all' : 'monetize');
      if (fittedValue !== null && fittedValue > 0) {
        return true;
      }

      return false;
    },

    async handleSearch() {
      if (!this.queryParams.gameName || this.queryParams.gameName.length === 0) {
        this.$message.warning('请至少选择一个游戏名称');
        return;
      }

      this.loading = true;
      // 清除缓存
      this.profitCache = {};

      try {
        const response = await axios.get('/getMpCookie/data', {
          params: {
            ...this.queryParams,
            gameName: this.queryParams.gameName.join(',') // 将数组转为逗号分隔的字符串
          }
        });

        if (response.data.code === 200 || response.data.success) {
          let results = response.data.data;
          
          // 处理多个游戏的结果
          let allTableData = [];
          
          if (Array.isArray(results)) {
            // 使用 for...of 替代 forEach，以支持 await
            for (const resultItem of results) {
              const gameName = resultItem.gameName;
              let rawData = resultItem.data;
              
              // 检查是否需要重试：data 为 null 或返回错误数据
              let needRetry = false;
              let retryReason = '';
              
              // 情况1: data 为 null
              if (rawData === null || rawData === undefined) {
                needRetry = true;
                retryReason = '数据为空';
              }
              // 情况2: data 是字符串且包含错误信息
              else if (typeof rawData === 'string') {
                try {
                  const parsedData = JSON.parse(rawData);
                  if (parsedData.ret && parsedData.ret !== 0) {
                    needRetry = true;
                    retryReason = `返回错误: ${rawData}`;
                  }
                } catch (e) {
                  // 如果不是JSON格式，继续正常处理
                }
              }
              
              // 执行重试逻辑
              if (needRetry) {
                console.warn(`游戏 ${gameName} ${retryReason}，正在重试...`);
                this.$message.warning(`游戏 ${gameName} 数据获取失败，正在重试...`);
                
                // 重试逻辑：最多重试3次
                let retryCount = 0;
                const maxRetries = 3;
                let retrySuccess = false;
                
                while (retryCount < maxRetries && !retrySuccess) {
                  retryCount++;
                  console.log(`第 ${retryCount} 次重试游戏 ${gameName}...`);
                  
                  // 等待1秒后重试
                  await new Promise(resolve => setTimeout(resolve, 1000));
                  
                  try {
                    const retryResponse = await axios.get('/getMpCookie/data', {
                      params: {
                        ...this.queryParams,
                        gameName: gameName // 单独请求该游戏
                      }
                    });
                    
                    if (retryResponse.data.code === 200 || retryResponse.data.success) {
                      const retryResult = retryResponse.data.data;
                      if (Array.isArray(retryResult) && retryResult.length > 0) {
                        rawData = retryResult[0].data;
                        
                        // 检查重试后的数据是否有效
                        if (rawData === null || rawData === undefined) {
                          console.warn(`第 ${retryCount} 次重试仍然返回空数据`);
                        } else if (typeof rawData === 'string') {
                          try {
                            const retryParsed = JSON.parse(rawData);
                            if (retryParsed.ret && retryParsed.ret !== 0) {
                              console.warn(`第 ${retryCount} 次重试仍然失败`);
                            } else {
                              retrySuccess = true;
                              console.log(`第 ${retryCount} 次重试成功`);
                            }
                          } catch (parseError) {
                            // 解析失败，但 rawData 不是 null，认为成功
                            retrySuccess = true;
                            console.log(`第 ${retryCount} 次重试成功（非JSON格式）`);
                          }
                        } else {
                          // rawData 是对象且不为 null，认为成功
                          retrySuccess = true;
                          console.log(`第 ${retryCount} 次重试成功`);
                        }
                      }
                    }
                  } catch (retryError) {
                    console.error(`第 ${retryCount} 次重试异常:`, retryError);
                  }
                }
                
                if (!retrySuccess) {
                  this.$message.error(`游戏 ${gameName} 重试${maxRetries}次后仍然失败`);
                  continue; // 跳过这个游戏，继续处理下一个
                }
              }
              
              if (typeof rawData === 'string') rawData = JSON.parse(rawData);

              if (rawData && rawData.reg_list) {
                let tempList = rawData.reg_list.map(item => {
                  const roiMap = {};
                  if (item.active_data && Array.isArray(item.active_data)) {
                    item.active_data.forEach(data => {
                      roiMap[data.day_delta] = data;
                    });
                  }
                  return {
                    ...item,
                    gameName: gameName, // 添加游戏名称字段
                    _roiMap: roiMap,
                    _fitData: null
                  };
                });

                allTableData = allTableData.concat(tempList);
              }
            }
            
            // 统一请求所有游戏的预估数据（多选方式）
            if (allTableData.length > 0) {
              try {
                const fitParams = {...this.queryParams, action: 'get_md_roi_fit'};
                const fitResponse = await axios.get('/getMpCookie/data', {
                  params: {
                    ...fitParams,
                    gameName: this.queryParams.gameName.join(',') // 多选方式请求
                  }
                });

                if (fitResponse.data.code === 200 || fitResponse.data.success) {
                  let fitResults = fitResponse.data.data;
                  
                  if (Array.isArray(fitResults)) {
                    // 构建游戏名 -> 预估数据的映射
                    const fitDataByGame = {};
                    fitResults.forEach(fitResult => {
                      const gName = fitResult.gameName;
                      let fitRaw = fitResult.data;
                      if (typeof fitRaw === 'string') fitRaw = JSON.parse(fitRaw);
                      
                      if (fitRaw && fitRaw.fit_list) {
                        const fitMap = {};
                        fitRaw.fit_list.forEach(fitItem => {
                          fitMap[fitItem.reg_ds] = fitItem;
                        });
                        fitDataByGame[gName] = fitMap;
                      }
                    });
                    
                    // 为每条数据匹配对应的预估数据
                    allTableData = allTableData.map(row => {
                      const gameFitMap = fitDataByGame[row.gameName];
                      if (gameFitMap && gameFitMap[row.reg_ds]) {
                        row._fitData = gameFitMap[row.reg_ds];
                      }
                      return row;
                    });
                  }
                }
              } catch (fitError) {
                console.warn('预估数据请求失败', fitError);
              }
            }
          }
          
          if (allTableData.length > 0) {
            this.tableData = allTableData.sort((a, b) => {
              // 先按游戏名排序，再按注册日期排序
              if (a.gameName !== b.gameName) {
                return a.gameName.localeCompare(b.gameName);
              }
              return b.reg_ds - a.reg_ds;
            });
          } else {
            this.tableData = [];
            this.$message.info('未找到相关数据');
          }
        } else {
          this.$message.error(response.data.msg || '查询失败');
        }
      } catch (error) {
        console.error(error);
        this.$message.error('网络异常或接口报错');
      } finally {
        this.loading = false;
      }
    },
  }
};
</script>

<style scoped>
.mp-data-container {
  padding: 20px;
  background-color: #f0f2f6;
  min-height: 100vh;
}

/* 搜索卡片样式 */
.search-card {
  margin-bottom: 20px;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.search-card >>> .el-card__body {
  padding: 20px 24px;
}

.search-form {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.search-form >>> .el-form-item {
  margin-bottom: 0;
  margin-right: 16px;
}

.search-form >>> .el-form-item__label {
  font-weight: 500;
  color: #606266;
}

/* 表格卡片样式 */
.table-card {
  border-radius: 12px;
  overflow: hidden;
}

.table-card >>> .el-card__header {
  padding: 16px 20px;
  border-bottom: 1px solid #e9ecef;
  background: linear-gradient(to bottom, #fafbfc, #ffffff);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 16px;
  color: #2c3e50;
}

.header-left i {
  font-size: 18px;
  color: #409eff;
}

.header-right {
  display: flex;
  align-items: center;
}

/* 表格容器 */
.table-wrapper {
  overflow-x: auto;
  position: relative;
}

/* 表格样式优化 */
>>> .el-table {
  font-size: 12px;
}

>>> .el-table th {
  background-color: #f8f9fa;
  color: #2c3e50;
  font-weight: 600;
  padding: 12px 0;
}

>>> .el-table td {
  padding: 10px 0;
}

>>> .el-table--border th,
>>> .el-table--border td {
  border-right: 1px solid #e9ecef;
}

>>> .el-table--border {
  border: 1px solid #e9ecef;
}

>>> .el-table__fixed {
  box-shadow: 2px 0 6px rgba(0, 0, 0, 0.05);
}

.date-text {
  font-weight: 500;
  color: #2c3e50;
}

.game-name-text {
  font-weight: 500;
  color: #409eff;
  font-size: 12px;
}

.period-text {
  font-weight: 600;
  color: #e39f0b;
  font-size: 13px;
}

.number-value {
  font-size: 12px;
  color: #4b4b4f;
  text-align: right;
  font-weight: 500;
}

/* ROI 单元格样式 */
.roi-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 2px 0;
}

.roi-real {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.roi-fit {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.roi-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 12px;
  line-height: 1.4;
}

.roi-item.all .roi-value {
  //font-weight: 500;
}

.roi-item.monetize .roi-value {
  //font-weight: 500;
}

.roi-item.fit .roi-value {
  //font-weight: 540;
}

.updated-marker-icon {
  color: #e39f0b;
  font-size: 12px;
  margin-right: 3px;
  vertical-align: middle;
}

.yugu {
  color: #3a8ee6;
  //font-weight: 540;
}

.yugu2 {
  color: #2c3e50;
  //font-weight: 500;
}

.profit-positive {
  color: #d65055;
  //font-weight: 600;
  //font-family: 'Consolas', monospace;
  font-size: 12px;
}

.profit-negative {
  color: #5daf34;
  //font-weight: 600;
  //font-family: 'Consolas', monospace;
  font-size: 12px;
}

.profit-zero {
  color: #909399;
  font-weight: 500;
  font-size: 12px;
}

/* 实际数据 - 黑色 */
.roi-real .roi-value {
  color: #2c3e50;
}

/* 预估/拟合数据 - 蓝色 */
.roi-fit .yugu {
  color: #3a8ee6;
}

.roi-label {
  font-size: 12px;
  color: #909399;
  font-weight: normal;
}

.roi-ratio {
  font-size: 12px;
  color: #5c5d5e;
  margin-left: 2px;
}

.roi-ratio-fit {
  font-size: 12px;
  color: #d65055;
  margin-left: 2px;
}



.no-data {
  color: #e4e7ed;
  font-size: 12px;
  text-align: center;
  padding: 8px 0;
}

/* 汇总行样式 */
>>> .el-table__body tr:first-child {
  //background-color: #fff7e6 !important;
}

>>> .el-table__body tr:first-child td {
  //background-color: #fff7e6 !important;
  //border-bottom: 2px solid #ffd591;
}

.summary-text {
  //font-weight: 600;
  //color: #d46b08;
  //font-size: 13px;
}

.summary-number {
  //font-weight: 600;
  //color: #d46b08;
  //font-size: 13px;
  //font-family: 'Consolas', monospace;
}

.summary-roi {
  //font-weight: 600;
}

.summary-roi .yugu {
  //color: #d46b08;
  //font-weight: 600;
  //font-size: 13px;
}

/* 表格滚动条美化 */
>>> .el-table__body-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

>>> .el-table__body-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

>>> .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

>>> .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .mp-data-container {
    padding: 12px;
  }

  .search-form >>> .el-form-item {
    margin-right: 12px;
  }

  .search-form >>> .el-form-item__label {
    font-size: 12px;
  }
}
</style>